const Options = () => {
  return (
    <>
      {/* <option value="1">1</option>
      <option value="2">2</option> */}
      <option value="10">10</option>
      <option value="15">15</option>
      <option value="20">20</option>
      <option value="25">25</option>
    </>
  );
};

export default Options;
